import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useCreateFoldersUserSelectionMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ folderId }) => {
      const response = await axios.post(`/folders/${folderId}/user_selections`);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['folders', 'recents']);
    },
  });
}
